export default __webpack_public_path__ + "static/media/image_1.3f8c9322.png";